import React from 'react';
import { Helmet } from 'react-helmet';

const StructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LegalService",
    "name": "Ochoa Herrera & Asociados",
    "image": "https://customer-assets.emergentagent.com/job_661426c8-676a-4387-8d77-4e9e1aa6a517/artifacts/1a2m54ip_Logo%20OH%20%26%20Asociados.png",
    "@id": "https://ochoaherrera.com.mx",
    "url": "https://ochoaherrera.com.mx",
    "telephone": "+52-777-149-5537",
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Fray Bartolomé de las Casas 17, Despacho 8C, Interior de Plaza Arcángel",
      "addressLocality": "Cuernavaca",
      "addressRegion": "Morelos",
      "postalCode": "62000",
      "addressCountry": "MX"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.9187654321098,
      "longitude": -99.2341234567890
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday"
        ],
        "opens": "09:00",
        "closes": "18:00"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/ochoaherreraasociados",
      "https://www.instagram.com/ochoaherreraasociados",
      "https://www.linkedin.com/company/ochoaherreraasociados"
    ],
    "areaServed": {
      "@type": "City",
      "name": "Cuernavaca"
    },
    "serviceType": [
      "Derecho Civil",
      "Derecho Penal",
      "Derecho Familiar",
      "Derecho Laboral",
      "Derecho Mercantil",
      "Derecho Corporativo",
      "Derecho Administrativo",
      "Juicio de Amparo"
    ],
    "description": "Despacho jurídico en Cuernavaca con más de 11 años de experiencia. Ofrecemos asesoría legal con enfoque humanista en diversas áreas del derecho.",
    "founder": {
      "@type": "Person",
      "name": "Ochoa Herrera"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+52-777-149-5537",
      "contactType": "customer service",
      "areaServed": "MX",
      "availableLanguage": ["Spanish"]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
